import type { StatefulDiaryT } from "@/types/database/diaries";
import { UUIDs } from "@/types/uuids";
import dayjs from "dayjs";
import type { PatientData } from "../../patients-data";
import type { ChartDataItem } from "../../utils/chart-values";

export const timePoints = [
	"Baseline",
	"3 month",
	"6 month",
	"9 month",
	"1 year",
	"2 year",
	"3 year",
] as const;

export type TimePoint = (typeof timePoints)[number];

export interface VasDataPoint {
	name: string;
	"VAS Score": number;
}

export interface VasChartConfig {
	"VAS Score": {
		label: string;
		color: string;
	};
}

export const vasChartConfig: VasChartConfig = {
	"VAS Score": {
		label: "VAS Score",
		color: "hsl(var(--chart-1))",
	},
};

export function roundTo1DP(value: number): number {
	return Math.round(value * 10) / 10;
}

export function formatPercentage(value: number): string {
	return `${Math.round(value * 100)}%`;
}

export function processVasData(patients: PatientData[]): VasDataPoint[] {
	const dataPoints: VasDataPoint[] = [];

	// Process each patient's VAS data
	for (const patient of patients) {
		for (const entry of patient.vas) {
			const existingPoint = dataPoints.find(
				(point) => point.name === entry.label,
			);
			if (existingPoint) {
				existingPoint["VAS Score"] =
					(existingPoint["VAS Score"] + entry.score) / 2;
			} else {
				dataPoints.push({
					name: entry.label,
					"VAS Score": entry.score,
				});
			}
		}
	}

	return dataPoints;
}

export function getVasAverage(data: VasDataPoint[]): VasDataPoint {
	const avgScore =
		data.reduce((sum, d) => sum + d["VAS Score"], 0) / data.length;

	return {
		name: "Average",
		"VAS Score": roundTo1DP(avgScore),
	};
}
